module.exports = __webpack_public_path__ + "assets/images/login_bg.jpg?8cca80a3";